import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'jhi-requete-title',
  templateUrl: './requete-title.component.html',
  styleUrls: ['./requete-title.component.scss']
})
export class RequeteTitleComponent implements OnInit {

  @Input()
  numeroRequete: string;

  @Input()
  siteJuridictionLabel: string;

  @Input()
  affectation: string;

  @Input()
  titre: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/requete-title/requete-title.component.ts